import React from 'react';
import possibilityImage from '../../assets/possibility.png';
import './possibility.css';

const Possibility = () => (
  <div className="gpt3__possibility section__padding" id="possibility">
    <div className="gpt3__possibility-image">
      <img src={possibilityImage} alt="possibility" />
    </div>
    <div className="gpt3__possibility-content">
      <h4>The Homebrew Way</h4>
      <h1 className="gradient__text">Brand Identity + Positioning <br /> Advertising + Branded Content</h1>
      <p>We design brands that connect to audiences through shared culture and values, and that explore the cultural tensions that determine loyalties and behaviours. We produce category-defining advertising and marketing that connects brands with their customers. We use the power of creativity and storytelling to solve problems and deliver results.</p>
    </div>
  </div>
);

export default Possibility;
